import { prettyPrintEnumValue } from "encamp-shared/src/utils/prettyPrintEnumValue";
import type { WebAutomationAction } from "generated-graphql/graphql";

/**
 * Pretty-prints a WebAutomationAction for display (e.g. "extractData" → "Extract Data").
 */
export function prettyPrintWebAutomationAction(
  action: WebAutomationAction | null | undefined
): string {
  if (action == null) {
    return "—";
  }
  return prettyPrintEnumValue(action) || action;
}
